import { LocationInterface } from 'interfaces/location.interface';
import { ReduxSimpleActionInterface } from '@ecommerce/nest-ssr';
import { updateLocation } from 'helpers/update-location.helper';

export enum LocationActions {
    UpdateLocation = 'UPDATE_LOCATION'
}

interface UpdateLocationPayloadInterface {
    path?: string;
    query?: Record<string, string | number | null>;
}

export const location = [
    (
        state: LocationInterface,
        action: ReduxSimpleActionInterface<LocationActions.UpdateLocation, { payload: UpdateLocationPayloadInterface; }>
    ): LocationInterface => {
        switch (action.type) {
            case LocationActions.UpdateLocation:
                // eslint-disable-next-line no-case-declarations
                const newState = updateLocation(state, action.payload);

                history.replaceState(
                    '',
                    '',
                    newState.url + document.location.hash
                );

                return newState;
            default:
                return state;
        }
    }
];
